import React from "react";
import PropTypes from "prop-types";
import { Redirect, Route } from "react-router-dom";

export const PublicRouter = ({
  Autenticado,
  origin,
  component: Component,
  ...rest
}) => {
  return (
    <Route
      {...rest}
      component={(props) =>
        !Autenticado ? (
          <Component {...props} />
        ) : origin === "NotificacionOneSignal" ? (
          <Redirect to={`/Home/Mensajeria`} />
        ) : (
          <Redirect to={`/`} />
        )
      }
    />
  );
};

PublicRouter.propTypes = {
  Autenticado: PropTypes.bool.isRequired,
  component: PropTypes.func.isRequired,
};
